export { WheelSpinGameCoreModule } from './wheel-spin-game-core.module';
export { WheelSpinGameSelectorComponent } from './wheel-spin-game-selector/wheel-spin-game-selector.component';
export { WheelSpinGameCoreService } from './wheel-spin-game-core.service';
export { IWheelSpinGame } from './wheel-spin-game.interface';
